<template>
    <div class="tab-pane active">
        <router-view :deal="deal"></router-view>
        <div class="row p-20">
            <div class="col-md-6 m_md_bottom_15">
                <router-link :to="{ name: 'deals.show.emails.create', params: { deal: deal.id } }" class="btn btn-default" v-if="lead.email && deal.editable">
                    <span class="btn-label">
                        <i class="fa fa-plus-circle"></i>
                    </span>
                    {{ $t('email') }}
                </router-link>
                <span class="btn btn-default" disabled v-pml-tooltip.top-right="$t('email_needed_to_do_so')" v-if="!lead.email && deal.editable"><i class="fa fa-plus-circle"></i> {{ $t('email') }} </span>
                <span class="pull-right m-t-10">{{ $t('data_grid_entries_showing', [getLength()]) }}</span>
            </div>
            <div class="col-md-6">
                <input type="text" class="form-control" :placeholder="`${$t('search')}...`" v-model="listConfig.filter">
            </div>
        </div>
        <div v-pml-block="isLoading">
            <div class="bg_grey_light p_bottom_15 p-t-15" v-if="scheduledRecords.length>0">
                <div class="bg_white clearfix">
                    <h5 class="text-center bold text-uppercase"><i class="fa fa-clock-o fa-fw m-r-10"></i>{{ $t('scheduled_emails') }}</h5>
                    <div class="table-responsive">
                        <table class="table table-striped table-bordered m-0">
                            <thead>
                                <tr>
                                    <th class="t_center max_w_100">{{ $t('scheduled_to') }}</th>
                                    <th class="t_center" colspan="3">{{ $t('participants') }}</th>
                                    <th class="t_center">{{ $t('subject') }}</th>
                                    <th class="t_center max_w_120">{{ $t('actions') }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <PmlItem v-for="(item, index) in scheduledRecords" :key="item.id" :item="item"></PmlItem>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="bg_white">
                <h5 class="text-center bold text-uppercase" v-if="scheduledRecords.length>0"><i class="icon-envelope-letter fa-fw m-r-10"></i>{{ $t('sent_emails') }}</h5>
                <div class="table-responsive">
                    <table class="table table-striped table-bordered m-0">
                        <thead>
                            <tr>
                                <th class="t_center max_w_100 th_sort" @click.prevent="setOrder('created_at')" :class="isOrderedColumn('created_at')">{{ $t('sent_at') }}</th>
                                <th class="t_center" colspan="3">{{ $t('participants') }}</th>
                                <th class="t_center th_sort" @click.prevent="setOrder('subject')" :class="isOrderedColumn('subject')">{{ $t('subject') }}</th>
                                <th class="t_center max_w_100 th_sort" @click.prevent="setOrder('status')" :class="isOrderedColumn('status')">{{ $t('status') }}</th>
                                <th class="t_center max_w_120">{{ $t('actions') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <PmlItem v-for="(item, index) in sentRecords" :key="item.id" :item="item"></PmlItem>
                            <tr v-show="!sentRecords.length">
                                <td class="t_center" colspan="7"><i class="fa fa-exclamation-triangle"></i> {{ $t('no_records_found') }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import TableFilters from 'utils/mixins/table-filters'
    import PmlItem from './Item.vue'
    import { findMember } from 'utils/helpers/find-store'
    import { mapGetters } from 'vuex'
    import { filter } from 'lodash'

    export default {
        name: 'Emails',
        mixins: [ TableFilters ],
        components: {
            PmlItem
        },
        data () {
            return {
                isLoading: false,
                listConfig: {
                    orderProp: 'created_at',
                    orderDir: 'desc',
                    columns: ['subject', 'status']
                }
            }
        },
        computed: {
            ...mapGetters({
                'deal': 'getDealInfo',
                'lead': 'getLeadInfo',
                'emails': 'getDealEmails'
            }),
            records () {
                return this.emails
            },
            sentRecords () {
                return filter(this.list, function (o) {
                    return o.status !== 'scheduled'
                }) || []
            },
            scheduledRecords () {
                return filter(this.emails, function (o) {
                    return o.status === 'scheduled'
                }) || []
            }
        },
        methods: {
            findMember: (id) => findMember(id),
            showEmail (record) {
                var url = `${process.env.URL_LOCAL}/deals/${this.deal.id}/emails/${record.id}`
                window.open(url, '', 'height=550,width=850')
            },
            getLength () {
                return this.sentRecords.length + this.scheduledRecords.length
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/deals/components/show/emails/Main.vue